// import styles from './orders-page.module.scss'
import { PageContainer, PageHeader } from "@touche-lts/panel-ui/dist"
import { IconActionHistory } from 'assets/icons'
import { useRootStore } from "mobx-stores/store-provider"
import { useEffect } from "react"
import { ActionHistoryTable } from './action-history-table/action-history-table'

const ActionHistoryPageComponent =  (props) => {
    const {
      className,
      style,
      history: { push }
    } = props,
      {
        departmentsStore: {
          resetStore
        }
      } = useRootStore()
  
    useEffect(() => {
      resetStore()
    }, [resetStore])
  
    return (
      <PageContainer className={className} style={style}>
        <PageHeader
          navSegments={[
            {
              icon: IconActionHistory,
              label: 'Action History',
              iconProps: { viewBox: '0 0 22 22' }
            }
          ]}
        />
        <ActionHistoryTable />
      </PageContainer>
    )
  }
  
  const ActionHistoryPage = ActionHistoryPageComponent
  export { ActionHistoryPage }